export default "__VITE_ASSET__9013c8ce__"